import { Loader } from '@/helpers/Loader'
import { getRegistry } from '@/services/Api/actions/registries/actions'
import { RegistrySearchItem, RegistryShort } from '@/services/Api/generated'
import { makeAutoObservable, runInAction } from 'mobx'
import { toast } from 'react-toastify'

export class RegistryInfoStore {
  data: RegistryShort | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  dataLoader = new Loader(
    async ({ registry }: { registry: RegistrySearchItem }) => {
      const registrationNumber = 'TM-' + registry.folderName + registry.number

      if (
        this.data != null &&
        this.data.registrationNumber === registrationNumber
      ) {
        return
      }

      runInAction(() => {
        this.data = null
      })

      try {
        const response = await getRegistry(registrationNumber)

        if (response.status) {
          runInAction(() => {
            this.data = response.data
          })
        }
        return null
      } catch (error) {
        toast.error('Что то пошло не так! Попробуйте позже')
      }
    }
  )
}
